module.exports = __webpack_public_path__ + "img/illu-coral.1d765bfa.svg";